import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_overlay_module = _resolveComponent("overlay-module")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
				'hd-mod-frame-target',
				_ctx.activeFrame,
				'crux-click'
			]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processOverlay('therapeutic-target'))),
          "data-crux": "frame-target"
        }, [
          _createVNode(_component_lyra_asset, { "asset-key": "mod-therapeutic-target" })
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.overlay === 'therapeutic-target')
          ? (_openBlock(), _createBlock(_component_overlay_module, {
              key: 0,
              modifier: "content-fit"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lyra_asset, {
                  class: "hd-mod-frame-target__overlay-content",
                  "asset-key": `mod-therapeutic-target-${_ctx.activeFrame}`
                }, null, 8, ["asset-key"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}